import {Fetch, JsonFetch} from 'mc/lib/utils';
import ErrorApi from './CustomErrorApi';

const formDataHeaders = () => {
    const headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    return headers;
};

export default class Api {

    static baseUrl = serverContextPath + '/api';

    static zadost = Api.baseUrl + '/zadost';

    static typZabor = Api.baseUrl + '/zabor/typ';

    static adresa = Api.baseUrl + '/adresa';

    static user = Api.baseUrl + '/user';

    static auth = Api.baseUrl + '/auth';

    static login(username: string, password: string) {
        return Fetch.post(Api.auth +'/loginsimple', 'username=' + username + '&password=' + password, Fetch.defaultProps, formDataHeaders());
    }

    static isOpenIdConfigured() {
        return Fetch.get(Api.auth + '/isopenidconfigured');
    }

    static loginByOpenId() {
        let promise = Fetch.get(Api.auth + '/loginbyopenid');
        promise.then(response => {
            response.text().then(data => {
                if (data === "true") {
                    window.location.reload(true);
                }
            })
        });
    }

    static logout() {
        return Fetch.post(Api.auth +'/logout', '', Fetch.defaultProps, formDataHeaders());
    }

    static register(email: string, password: string, firstname: ?string = null, lastname: ?string = null, idTypZabor: ?number = null) {
        return ErrorApi.responseResolver(JsonFetch.post(serverContextPath + '/register', null, {email, password, firstname, lastname, idTypZabor}));
    }

    static passwordRecovery(email: string) {
        return ErrorApi.responseResolver(JsonFetch.post(serverContextPath + '/password-recovery', null, {email}));
    }

    static passwordChange(password: string, token: ?string = null) {
        return ErrorApi.responseResolver(JsonFetch.post(serverContextPath + '/password-change', null, {token, password}));
    }

    static checkZadost(data: Object) {
        return ErrorApi.responseResolver(JsonFetch.post(serverContextPath + '/check', null, data))
    }

    static getUser() {
        return ErrorApi.responseResolver(JsonFetch.get(Api.user));
    }

    static saveUserSubjekt(subjekt: Object) {
        return ErrorApi.responseResolver(JsonFetch.post(Api.user + '/subjekt', null, subjekt))
    }

    static deleteUserSubjekt() {
        return ErrorApi.responseResolver(JsonFetch.delete(Api.user + '/subjekt'))
    }

    static createZadost(idTypZabor: number) {
        return ErrorApi.responseResolver(JsonFetch.post(Api.zadost, null, {idTypZabor}));
    }

    static getZadost(id: number, priloha: boolean = false, subjekt: boolean = false, lokalita: boolean = false) {
        return ErrorApi.responseResolver(JsonFetch.get(Api.zadost + '/' + id, {priloha, subjekt, lokalita}));
    }

    static getZadostList() {
        return ErrorApi.responseResolver(JsonFetch.get(Api.zadost));
    }

    static getTypZaborList(query: string = "") {
        return ErrorApi.responseResolver(JsonFetch.get(Api.typZabor, {query}));
    }

    static getTypZabor(id: number) {
        return ErrorApi.responseResolver(JsonFetch.get(Api.typZabor + '/' + id));
    }

    static closeZadost(id: number) {
        return ErrorApi.responseResolver(JsonFetch.post(Api.zadost + '/' + id + '/uzavrit'));
    }

    static deleteZadost(idZadost: number) : Promise<Object> {
        return ErrorApi.responseResolver(JsonFetch.delete(Api.zadost + '/' + idZadost));
    }

    static duplicateZadost(idZadost: number) : Promise<Object> {
        return ErrorApi.responseResolver(JsonFetch.post(Api.zadost + '/' + idZadost + '/duplicate'));
    }

    static savePriloha(idZadost: number, idTypPriloha: number, stav: string, file: any) {
        const formData = new FormData();
        formData.append("idTypPriloha", idTypPriloha);
        formData.append("stav", stav);
        formData.append("file", file);
        return ErrorApi.responseResolver(Fetch.post(Api.zadost + '/' + idZadost + '/priloha', formData));
    }

    static setSubjekt(idZadost: number, idRoleSubjekt: number, subjekt: Object) {
        return ErrorApi.responseResolver(JsonFetch.post(Api.zadost + '/' + idZadost + '/subjekt/' + idRoleSubjekt, null, subjekt))
    }

    static updateLokalita(idZadost:number, lokalita: Object) : Promise<Object> {
        return ErrorApi.responseResolver(JsonFetch.put(Api.zadost + '/' + idZadost + '/lokalita/' + lokalita.id, null, lokalita));
    }

    static createLokalita(idZadost:number, lokalita: Object) : Promise<Object> {
        return ErrorApi.responseResolver(JsonFetch.post(Api.zadost + '/' + idZadost + '/lokalita/', null, lokalita));
    }

    static createLokalitaDokumenty(idZadost: number, idLokalita: number, souborList: Resource[]) : Promise<Object> {
        const data = new FormData();
        if (souborList && Array.isArray(souborList)) {
            for (const soubor of souborList) { // extrakce souborů do pole na stejné indexy
                data.append("files", soubor);
            }
        }
        return ErrorApi.responseResolver(Fetch.post(Api.zadost + '/' + idZadost + '/lokalita/' + idLokalita + '/dokument', data));
    }

    static deleteLokalita(idZadost:number, idLokalita: number) : Promise<Object> {
        return ErrorApi.responseResolver(JsonFetch.delete(Api.zadost + '/' + idZadost + '/lokalita/' + idLokalita));
    }

    static deleteSubjekt(idZadost: number, idSubjekt: number) {
        return ErrorApi.responseResolver(JsonFetch.delete(Api.zadost + '/' + idZadost + '/subjekt/' + idSubjekt));
    }

    static setZadatel(idZadost: number, subjekt: Object) {
        return ErrorApi.responseResolver(JsonFetch.post(Api.zadost + '/' + idZadost + '/zadatel', null, subjekt))
    }

    static deleteZadatel(idZadost: number) {
        return ErrorApi.responseResolver(JsonFetch.delete(Api.zadost + '/' + idZadost + '/zadatel'));
    }
}
